// Canonical source for these action types, so v2/'s auth bridge middleware
// (src/v2/stores/auth/bridge.ts) can import a real, typed value from here
// instead of importing user.duck.js directly (which would need allowJs, since
// TypeScript can't type a .js file's exports without it).
export const CURRENT_USER_SHOW_SUCCESS = 'app/user/CURRENT_USER_SHOW_SUCCESS';
export const CURRENT_USER_SHOW_ERROR = 'app/user/CURRENT_USER_SHOW_ERROR';
export const CLEAR_CURRENT_USER = 'app/user/CLEAR_CURRENT_USER';
export const FETCH_CURRENT_USER_MEMBERSHIP_SUCCESS =
  'app/user/FETCH_CURRENT_USER_MEMBERSHIP_SUCCESS';
